import React, { Component } from 'react';
import { connect } from 'react-redux';

// Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

//Component
import RankItemGroupResponse from '../RankItem/RankItemGroupResponse/RankItemGroupResponse'
import { processItemResponse } from '../../../../utilities/processResponse';
// Actions
import { getAnsweredQuestionCount, getQuestionList } from '../../../../actions/SurveyAction';

//Assets
import './RankItem.css';

import { isMobile, isTablet } from 'react-device-detect';
class RankItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            undoIcon:false,
            naCheck:false
        }

        this.restoreSingleItemArr = [];
    }

    componentDidUpdate(prevProps) {
        var questionId = this.props.scrollToQuestionId;

        if (questionId !== null) {
            if (this.props.scrollToQuestionId !== prevProps.scrollToQuestionId) {
                this.scrollToQuestion(questionId);
            }
        }

    }

    /**
     * Method to scroll respective element based on id
     *
     * @param { questionId:string }
     *
     */
    scrollToQuestion = (questionId) => {
        var scrollDiv = document.getElementById("ScrollDiv_" + questionId);
            scrollDiv.style.paddingTop = "40px";
            scrollDiv.scrollIntoView({top:scrollDiv.offsetTop, behavior:"smooth"});
    }

    /**
     * Reset the question options
     *
     */
    resetAll = (event, configuration, rateeKey, naType) => {
        const { questionItemList, dispatch, answeredQuestionCount } = this.props;
        const { key } = configuration;
        const itemTagKey = key;
        var itemList = questionItemList[key];
        var nodeList = document.getElementsByClassName(`OpenEnd_${key}`);
        /** Question object  */
        itemList.filter((items, i) => {
            if (items.itemResponses.length > 0) {
                this.restoreSingleItemArr = items.itemResponses;
                this.setState({undoIcon:true});
            }

            var tempArr = this.restoreSingleItemArr.filter((el) => el !== null);

            if (items.key === itemTagKey) {

                if (naType) {
                    for (const key in nodeList) {
                        if (nodeList.hasOwnProperty(key)) {
                            const element = nodeList[key];
                            element.disabled = true;
                            element.value = "";
                        }
                    }
                }
                if (naType === "clear" || typeof naType === "boolean") {
                    items.itemResponses = [];
                    items.isAnswer = false;
                    items.isRequired = false ;

                    if (naType !== "clear") {
                        this.handleNaDisabled(naType, itemTagKey);
                        items.isNA = naType === false ? false : true;
                    }

                    for (const key in nodeList) {
                        if (nodeList.hasOwnProperty(key)) {
                            const element = nodeList[key];

                            if (naType !== "clear") {
                                element.disabled = naType ? true : false;
                            } else {
                                element.disabled = false;
                            }
                            element.value = "";
                        }
                    }
                    dispatch(getQuestionList(questionItemList));
                } else {
                    for (const key in nodeList) {
                        if (nodeList.hasOwnProperty(key)) {
                            const element = nodeList[key];
                            element.disabled = false;
                        }
                    }

                    /** Assign the value of input box */
                    tempArr.map((res, i) => {
                        document.getElementById(`OpenEndedInput_${i+1}`).value = res.userResponseDescription;
                    });
                    items.itemResponses = tempArr;
                    items.isAnswer = true;
                    items.isNA = false;
                    this.setState({undoIcon:false});
                }
            }
            return true;
        });
        let remainCount = answeredQuestionCount - 1;
        dispatch(getAnsweredQuestionCount(remainCount));
    }

    handleNaDisabled = (naType, itemTagKey) => {
        var scrollDiv = document.getElementById(`ScrollDiv_${itemTagKey}`);
        scrollDiv.style.fontStyle = naType === false ? 'normal' :'italic';
        scrollDiv.style.color = naType === false ? '#0f5ea0' :'#8787';
    }
    /**
     * Method to load spinner image
     *
     */
    renderSpinner = (configuration) => {
        return <i className={`fa fa-spinner fa-spin fa_${configuration.key}`} style={{"fontSize":"25px", "display":"none"}}></i>
    }

    //new added code
    handleDependencyRequired = ( itemKey, response) => {
      try {
          var test = setTimeout(() => {
          const { pageList, nextPageKey, activePageKey } = this.props;

              var _blockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._block`);
              var _unBlockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._Unblock`);
          
              var _blockActivePageElement = document.querySelectorAll(`._SurveyPageLevel_${activePageKey} ._block`);
              var _unBlockActiveElement = document.querySelectorAll(`._SurveyPageLevel_${activePageKey} ._Unblock`);
              for (const key in pageList) {
                  if (Object.hasOwnProperty.call(pageList, key)) {
                      if (pageList[key].key == nextPageKey) {
                          const tempItems = pageList[key].items;
                          for (const key in tempItems) {
                              if (Object.hasOwnProperty.call(tempItems, key)) {
                                  const element = tempItems[key];

                                  for (const depKey in _blockElement) {
                                      if (Object.hasOwnProperty.call(_blockElement, depKey)) {
                                          const dataId = _blockElement[depKey].getAttribute('data-id');

                                          if (element.key === dataId) {
                                              element.isHide = false;
                                          }

                                      }
                                  }

                                  for (const bKey in _unBlockElement) {
                                      if (Object.hasOwnProperty.call(_unBlockElement, bKey)) {
                                          const dataIdUnblock = _unBlockElement[bKey].getAttribute('data-id');

                                          if (element.key === dataIdUnblock) {
                                              element.isHide = true;
                                          }
                                      }
                                  }
                                  //this.props.handleDynamicDependency( dep.key, response);
                              }
                          }
                      } else {
                              if (pageList[key].key == activePageKey) {
                                  const tempItems = pageList[key].items;
                                  for (const key in tempItems) {
                                      if (Object.hasOwnProperty.call(tempItems, key)) {
                                          const element = tempItems[key];
                                          if(this.props.dependencies != undefined) {
                                              for( const depKey in this.props.dependencies) {
                                                  this.props.dependencies[depKey].map((dep) => {
                                                      if(itemKey == dep.dependsOnKey && response == dep.response ){
                                                          this.props.handleDynamicDependency( dep.key, response,"samePage",element.requiredIndicator);
                                                          for (const depKey in _blockActivePageElement) {
                                                              if (Object.hasOwnProperty.call(_blockActivePageElement, depKey)) {
                                                                  const dataId = _blockActivePageElement[depKey].getAttribute('data-id');
                                                                  if (element.key === dataId) {
                                                                      element.isHide = false;
                                                                  }
                                                              }
                                                          }
                                                          for (const bKey in _unBlockActiveElement) {
                                                              if (Object.hasOwnProperty.call(_unBlockActiveElement, bKey)) {
                                                                  const dataIdUnblock = _unBlockActiveElement[bKey].getAttribute('data-id');
                                                                  if (element.key === dataIdUnblock) {
                                                                      element.isHide = true;
                                                                  }
                                                                  
                                                              }
                                                          }
                                                      }
                                                  });
                                              }
                                          }
                                      }
                                  
                                  }
                              }
                      }
                  } 
              }

              clearTimeout(test);
          }, 0);

      } catch (error) {

      }
  }

  
//   //new added 

  handleSkipPage = (tempResponseValue) => {
    try {
        const { dependencies, items } = this.props;
        var responseValue = tempResponseValue;
        var nodeList = document.getElementsByName(`MultiSelect_${items.key}`);

        for (const key in dependencies) {
            if (Object.hasOwnProperty.call(dependencies, key)) {
                const element = dependencies[key];

                element.filter((dep) => {
                    if (dep.dependsOnKey === items.key) {

                        var skipDiv = document.getElementById("survey-item-block_" + dep.key);
                        var skipDivOld = document.getElementsByName("survey-item-block");

                        var conditionString = "";
                        element.map((item, i) => {
                            return conditionString += `( ${item.response} ${item.booleanOperator} ${tempResponseValue} ) ${item.dependsOnConditionalOperator !== null ? item.dependsOnConditionalOperator : ""}`
                        });

                        var newStr = conditionString.length > 15 ? conditionString.substr(0, conditionString.length - 1) : conditionString;
                        var result = newStr.split(') |').join(")");
                        var newCondition = result.split('|').join("||");
                        if (newCondition !== '' && eval(newCondition)) {
                            for (const key in skipDivOld) {
                                if (Object.hasOwnProperty.call(skipDivOld, key)) {
                                    const dataId = skipDivOld[key].getAttribute('data-id');

                                    if (dataId == dep.key) {
                                        skipDivOld[key].classList.remove('_Unblock');
                                        skipDivOld[key].classList.add('_block');
                                        skipDivOld[key].classList.add(`_block_${items.key}_${responseValue}`);

                                        // setTimeout(() => {
                                        //     this.handleDependencyRequired(dataId, "block");
                                        // }, 1000);
                                    }
                                }
                            }

                            // this.handleDependencyRequired(dep.key, "block");
                            //return false;
                        } else {
                            if (this.state.isSelect) {
                                for (const key in nodeList) {
                                    if (Object.hasOwnProperty.call(nodeList, key)) {
                                        const element = nodeList[key];
                                        var newEl = document.getElementsByClassName(`_block_${items.key}_${element.value}`)[0];

                                        if (!element.checked) {
                                            var dataId = skipDivOld[key].getAttribute('data-id');

                                            if (newEl !== undefined) {
                                                newEl.classList.remove('_block');
                                                newEl.classList.remove(`_block_${items.key}_${element.value}`);
                                                newEl.classList.add('_Unblock');
                                            }
                                        } else {
                                            // this.handleDependencyRequired(dep.key, "none")
                                            // newEl.classList.add('_block');
                                            // skipDiv.style.display = "none";
                                        }
                                    }
                                }
                            } else {
                                skipDiv.style.display = "none";
                            }

                        }
                    }
                })
            }
        }
    } catch (error) {
        console.log("Exceptions: while skipping item and page", error.message);
    }
}
    renderTextArea(responseConfiguration) {
        const { configuration, questionItemList } = this.props;
        let key = this.currentRatee.key;

        return (
            <td>
                <RankItemGroupResponse
                    className={configuration.className}
                    configuration={responseConfiguration}
                    suppressLabel={true}
                    items={configuration}
                    questionItemList={questionItemList}
                    rateeKey={key}
                />
            </td>
        );
    }

    renderRatee(ratee, me) {
        const { configuration } = this.props;
        this.currentRatee = ratee;
        this.currentButtonGroup = [this.currentRatee.key, configuration.key].join(":");
        return this.renderTextArea(configuration, this);
    }

    /**
     * N/A check box functionality
     *
     */
    naOpenEndCheck = (event, configuration) => {
        try {
            //const { itemResponses } = this.props;

            var itemKey = configuration.key;
            var naCheck = event.target.checked;
            var surveyItem = document.getElementById(`survey-item-block_${itemKey}`);
            this.setState({naCheck:naCheck});
            if (naCheck) {
                surveyItem.style.background = "#F2F2F2";
                surveyItem.style.color = "#ACACAC";
                var responseSet = this.props.itemResponses[itemKey] = {};
                var itemResponses = [{
                    "itemType"     : configuration.itemType,
                    "buttonGroup"  : null,
                    "sequence"     : 1,
                    "isNa"         : naCheck,
                    "response"     : null,
                    "responseValue": null,
                    "openEnd"      : null,
                    "serverStatus" : 0,
                    "hasPosted"    : 0
                }];
                processItemResponse(itemKey, responseSet, itemResponses,"onChange");
                this.props.handleItemResponse(configuration.key, this.props.itemResponses, "itemChange");
            } else {
                surveyItem.style.background = "#fff";
                surveyItem.style.color = "#000";
            }

            this.resetAll(null, configuration, null, naCheck);
        } catch (error) {
            console.log("Exception: while check n/a checkbox in single select:_", error);
        }
    }

    /**
     * Restore value before selected
     *
     */
    resetOpenEndResponse = (event, configuration) => {
        this.resetAll(null, configuration, null, "reset");
    }

    renderView = (configuration, reviewPageKey) => {
        const { questionItemList, pageInstrumentConfiguration,activePageKey, itemResponses, itemTempResponses, getAllResponses, dataCollectionGuid, assessmentInfosForDataCollection } = this.props;
        const { scales } = pageInstrumentConfiguration;
        const scaleResponses = scales[configuration.scaleKey];
        const assessmentObj = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        return <RankItemGroupResponse
                key={configuration.key}
                configuration={scaleResponses}
                items={configuration}
                itemResponses={itemResponses}
                itemTempResponses={itemTempResponses}
                pageInstrumentConfiguration={pageInstrumentConfiguration}
                scaleResponses={scaleResponses}
                questionItemList={questionItemList}
                handleItemResponse={(itemKey, itemResponsesSet, type, dataGuid) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataGuid)}
                rateeKey={dataCollectionGuid}
                activePageKey={activePageKey}
                ratees={assessmentObj}
                putAllForItemCollection={this.props.putAllForItemCollection}
                getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}
            />
    }

    render() {
        const { configuration, ratees, questionItemList, pageInstrumentConfiguration } = this.props;
        const { scales, itemNaUncheckedButtonKey, itemResetButtonKey, itemRestoreButtonKey, buttons, properties } = pageInstrumentConfiguration;

        var jsx = '';
        var rateeKey = null;
        var tempQuestionList = [];
        var naResponse = scales[configuration.scaleKey].naResponse;

        for (const key in questionItemList) {
            if (questionItemList.hasOwnProperty(key)) {
                const element = questionItemList[key];
                tempQuestionList.push(element)
            }
        }

        for (const key in ratees) {
            if (ratees.hasOwnProperty(key)) {
                const element = ratees[key];
                rateeKey = element.key;
            }
        }

        const responseLength = tempQuestionList.filter((item, i) => {
            if (item.key === configuration.key ) {
                return item.userResponse.length || 0;
            }
        });
        let OSName = "Unknown OS";
        if (navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
        if (navigator.userAgent.indexOf("Mac") != -1) OSName = "Macintosh";
        if (navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
        if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
        if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "iOS";
        var groupIconsClass = configuration.hasItemResetButton || configuration.hasItemRestoreButton || naResponse !== null ? "ItemGroupIcon" : null;

        if (ratees.length < 2) {
            jsx = (
              <div
              data-id={configuration.key} //new added code
              name={`survey-item-block`}  // new added code
                id={`survey-item-block_${configuration.key}`}
              className={`survey-item-block_${configuration.key}`} //new added code
              style={(isMobile || isTablet) && OSName == "Android" ? {position:'relative', top:29} : null}
              >
                <Row
                  id={`ScrollDiv_${configuration.key}`}
                  className={
                    configuration.itemText !== null
                      ? `_ItemTextCss ${configuration.cssClass}`
                      : null
                  }
                >
                  {configuration.itemText && configuration.itemText !== null ? (
                    <>
                      <Col xs={1}>
                        <div className={"ItemSpinner"}>
                          {this.renderSpinner(configuration)}
                        </div>
                      </Col>
                      <Col
                        xs={
                          naResponse !== null &&
                          naResponse !== undefined &&
                          configuration.hasItemResetButton &&
                          configuration.hasItemRestoreButton
                            ? 10
                            : 10
                        }
                        className="itemText"
                      >
                        {configuration.isRequiredLabel === true ? (
                          <span className={"_AsteriskMark"}>
                            {properties.requiredIndicator}
                          </span>
                        ) : (
                          ""
                        )}
                        <span
                          className="itemTag"
                          dangerouslySetInnerHTML={{
                            __html: configuration.itemTag,
                          }}
                        ></span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: configuration.itemText,
                          }}
                        ></span>
                      </Col>
                      <Col xs={1}></Col>
                      <Col
                        xs={1}
                        className={groupIconsClass}
                        style={{
                          display:
                            naResponse !== null &&
                            naResponse !== undefined &&
                            configuration.hasItemResetButton &&
                            configuration.hasItemRestoreButton
                              ? "block"
                              : "none",
                        }}
                      >
                        {naResponse !== null && naResponse !== undefined ? (
                          <span
                            key={buttons[itemNaUncheckedButtonKey].key}
                            className={`_ItemNaUncheckedButton ${buttons[itemNaUncheckedButtonKey].buttonCssClass}`}
                          >
                            <Form.Check
                              type="checkbox"
                              onChange={(event) =>
                                this.naOpenEndCheck(event, configuration)
                              }
                            />{" "}
                            <span>
                              {buttons[itemNaUncheckedButtonKey].buttonText}
                            </span>
                          </span>
                        ) : null}
                        {configuration.hasItemResetButton ? (
                          <span
                            key={buttons[itemResetButtonKey].key}
                            className={`_ItemResetButton ${buttons[itemResetButtonKey].buttonCssClass}`}
                            onClick={(event) =>
                              this.resetAll(
                                event,
                                configuration,
                                rateeKey,
                                "clear"
                              )
                            }
                          >
                            {responseLength.length > 0 &&
                            this.state.undoIcon === false ? (
                              <i
                                className={
                                  buttons[itemResetButtonKey].buttonFontAwesome
                                }
                              ></i>
                            ) : null}
                          </span>
                        ) : null}
                        {configuration.hasItemRestoreButton ? (
                          <span
                            key={buttons[itemRestoreButtonKey].key}
                            className={`_ItemRestoreButton ${buttons[itemRestoreButtonKey].buttonCssClass}`}
                            onClick={(event) =>
                              this.resetOpenEndResponse(event, configuration)
                            }
                          >
                            {this.state.undoIcon === true &&
                            this.state.naCheck === false ? (
                              <i
                                className={
                                  buttons[itemRestoreButtonKey]
                                    .buttonFontAwesome
                                }
                              ></i>
                            ) : null}
                          </span>
                        ) : null}
                      </Col>
                    </>
                  ) : null}
                </Row>
                <Row className="_RankedRow">
                  <Col xs={1}></Col>
                  <Col xs={11}>
                    {configuration.isPlaceholder === false ? (
                      <span>This is the placeholder</span>
                    ) : null}
                  </Col>
                </Row>
                <Row>
                  <Col xs={1}>
                    <div className={"ItemSpinner"}>
                      {configuration.itemText === null
                        ? this.renderSpinner(configuration)
                        : null}
                      {/* { this.renderSpinner(configuration) } */}
                    </div>
                  </Col>
                  <Col xs={10} className={"_LIS_Item"}>
                    {this.renderView(configuration)}
                  </Col>
                  <Col xs={1}></Col>
                </Row>
              </div>
            );
        } else {
            jsx = (
                <div className='SingleSelectItem SingleOrMultiSelectItem'>
                    <div className='PreItemTextDiv'>
                        {/* { this.renderSpinner(configuration) } */}
                    </div>
                    <div id={`ScrollDiv_${configuration.itemTag}`} className='ItemTagItemText'>
                    <div className='ItemTag' dangerouslySetInnerHTML={{__html:configuration.itemTag}}></div>
                        <div className='ItemTagTextHorizontalSpacer'>
                            {configuration.isRequired === true ? <span className="Error_isRequired">*</span> :''}
                        </div>
                        <div className='ItemText' dangerouslySetInnerHTML={{__html: configuration.itemText}}></div>
                        <div className='clearButton'>
                            <button onClick={(event) => this.resetAll(event, configuration, rateeKey)}>Clear</button>
                        </div>
                    </div>
                    { configuration.isPlaceholder === true ? <div className='PostItemTextDiv'>This is placeholder</div>: null }
                    <div className='SingleOrMultiSelectGroup'>
                    <table id='table'>
                        <tbody>
                            {ratees != null ? ratees.map(ratee => {
                                    return (
                                        <tr key={ratee.dataCollectionGuid}>
                                            <td className='RateeName' title={ratee.relationshipDescription}>
                                                {ratee.participantName}
                                            </td>
                                            {this.renderRatee(ratee, this)}
                                        </tr>
                                    );
                                }, this) : null
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            )
        }
        return jsx;
    }
}

const mapStateToProps = state => ({
    scrollToQuestionId:state.survey.scrollToQuestionId,
    answeredQuestionCount:state.survey.answeredQuestionCount,
    assessmentInfosForDataCollection:state.survey.assessmentInfoDataCollectionData
});

export default connect(mapStateToProps)(RankItem);
